import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { AutoUnsubscribe, findDataInSnapshot } from 'helpers';
import { Observable, Subscription } from 'rxjs';
import { Branch } from 'models';
import { SegmentService, UserService } from 'services';
import { StoresModalComponent } from '../stores-modal/stores-modal.component';
import { ActivatedRoute } from '@angular/router';
import { TrackingEvents } from 'services/tracking/gtm';
import { selectStoreForCopyingModalId } from '../single-store-modal-for-copying/single-store-modal-for-copying.component';
import { SwitchToProductType } from '../../../retailer-platform/order/product-switch-modal/product-switch-modal.component';
import { StoreSelectorService } from 'app/b2b-order/services/store-selector/store-selector.service';

@Component({
    selector: 'store-dropdown',
    templateUrl: './store-dropdown.component.html',
    styleUrls: ['./store-dropdown.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
@AutoUnsubscribe
export class StoreDropdownComponent implements OnInit {
    @Input() title: string;
    @Input() buttonTitle: string;
    @Input() isDisplayed: boolean;
    @Input() chooseStoreModalId: string;
    @Output() storeCount = new EventEmitter<number>();
    @Output() hideDropdown = new EventEmitter<void>();

    public selectedStores: Observable<Branch[]>;
    public selectedStoreSubscription: Subscription;
    private clickedInside = false;

    @ViewChild(StoresModalComponent)
    private storesModalComponent: StoresModalComponent;

    constructor(
        private activatedRoute: ActivatedRoute,
        private storeSelectorService: StoreSelectorService,
        private segmentService: SegmentService,
        private userService: UserService
    ) {}

    ngOnInit() {
        this.selectedStores = this.storeSelectorService.selectedStores;
        this.selectedStoreSubscription = this.selectedStores.subscribe((stores) => this.storeCount.emit(stores.length));
    }

    openStoresModal(chooseStoreModalId: string) {
        this.storesModalComponent.displayModal(chooseStoreModalId);
        this.segmentService.track(TrackingEvents.EDIT_STORES_DISPLAY, {
            page_type: findDataInSnapshot(this.activatedRoute.snapshot, 'selectedMenu'),
            retailer_id: this.userService.getOrganizationId()
        });
    }

    getStoreName(store: Branch) {
        return (
            store.shortName?.trim() || `${store.name && store.name.trim() + ', '}${this.formatAddress(store.address)}`
        );
    }

    formatAddress(store: Branch['address']) {
        return `${store.address1}, ${store.zip}, ${store.city}`;
    }

    @HostListener('click')
    clickInsideComponentListener() {
        this.clickedInside = true;
    }

    @HostListener('document:click', ['$event.target'])
    clickOutsideComponentListener(targetElement: HTMLElement) {
        if (!this.clickedInside && this.isDisplayed && !targetElement.closest('#stores-dropdown')) {
            this.hideDropdown.emit();
        }
        this.clickedInside = false;
    }

    get getSelectStoreForCopyingModalId() {
        return selectStoreForCopyingModalId;
    }

    protected readonly SwitchToProductType = SwitchToProductType;
}
